import '../sass/Banner.scss'
import { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCode, faBars, faXmark } from '@fortawesome/free-solid-svg-icons'
function Banner() {
    const [open, setOpen] = useState(false)
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 700)

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 700)
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return <header>
        <nav>
            <a href='#name' className='logo'><FontAwesomeIcon icon={faCode} size='2xl' style={{color: "#2965FF"}} /></a>
            <button className='burger' onClick={() => setOpen(!open)}>
                <FontAwesomeIcon icon={open ? faXmark : faBars} size='xl' style={{color: "#8993A1"}} />
            </button>
            <div className={`nav-links ${open ? 'open' : ''}`}>
                <a href='#name' onClick={() => setOpen(false)}><p>ACCUEIL</p></a>
                <a href='#profil' onClick={() => setOpen(false)}><p>PROFIL</p></a>
                <a href={isMobile ? '#swiper' : '#skills'} onClick={() => setOpen(false)}><p>COMPETENCES</p></a>
                <a href='#timeline' onClick={() => setOpen(false)}><p>EXPERIENCES</p></a>
                <a href='#download' onClick={() => setOpen(false)}><p>MON CV</p></a>
                <a href='#contact' onClick={() => setOpen(false)}><p>CONTACT</p></a>
            </div>
        </nav>
    </header>
}
export default Banner